import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { formatString } from '../utils/string-utils';
import { firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class OrdersService {

	constructor(
		private configService: ConfigService,
		private http: HttpClient
	) { }
	
	async getOrders(page: number = 1, paging: any = {}, constraints: any = {}): Promise<any> {
		let url = this.configService.getConfig().transactions.ordersURL;
		url = url + "?page=" + page + "&size=" + paging.elementsPerPage + "&sort=" + paging.sorting.sort + "&constraints=" + encodeURIComponent(JSON.stringify(constraints));

		try {
			const response = await firstValueFrom(this.http.get<any>(url, {}));

			if (response?.content) {
				let orders = response.content;
				orders.forEach((order: any) => {
					this.formatOrder(order);
				});
				return response;
			} else {
				return Promise.reject(false);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	}

	private formatOrder(order: any) {
		if (!order) return;
		let created = new Date(order.created);
		order.createdStr = created.toLocaleDateString('en-US') + ' ' + created.toLocaleTimeString('en-US');
		let completed = new Date(order.completed);
		order.completedStr = completed.toLocaleDateString('en-US') + ' ' + completed.toLocaleTimeString('en-US');
		let resultExpiration = new Date(order.resultExpiration);
		order.expirationStr = resultExpiration.toLocaleDateString('en-US') + ' ' + resultExpiration.toLocaleTimeString('en-US');
		let downloadStr = formatString(this.configService.getConfig().transactions.ordersDownload, order.uuid);
		order.downloadStr = downloadStr;
		order.orderStatusPretty = this.capitalize(order.orderStatus);
	}

	private capitalize(string: string) {
		let allwords = [];
		let words = string.split("_");
		for (let i = 0; i < words.length; i++) {
			let w = words[i];
			allwords.push(w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
		}
		return allwords.join(' ');
	}
		
	async deleteOrder(id: number): Promise<any> {
		let url = this.configService.getConfig().transactions.ordersURL + "/delete/" + id;

		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	async deleteOrders(ids: any[]): Promise<any> {
		let url = this.configService.getConfig().transactions.ordersMassDeleteURL;

		try {
			return await firstValueFrom(this.http.post<any>(url, ids));
		} catch (error) {
			return Promise.reject(error);
		}
	}	
}
